export const popup_opening = 'popup_opening'
export const popup_closed = 'popup_closed'
export const popup_pending = 'popup_pending'
